










































































































































import { Component } from "vue-property-decorator";
import QuizPage from "../../components/QuizPage";
import DebugData from "../../components/DebugData.vue";
@Component({
  components: {
    DebugData
  }
})
export default class States extends QuizPage {
  private created() {
    this.init("states", "/software");
  }

  private goNextOverride() {
    if (this.selected.includes("il") || this.selected.includes("tx") || this.selected.includes("wa")) {
      this.nextPage = "/biometric";
    } else {
      // Clear biometric settings since we know there are none if we are skipping that page.
      // We have to do this in case the user went forward, choose Yes, then came back and cleared
      // the states with specific biometric regulations. If they happen to come back again and
      // select back in a biometric state they'll have to choose a new biometric setting.
      this.$store.commit("biometricSelection", "");
      this.$store.commit("biometricFrameworks", new Set<string>());
    }
    this.goNext();
  }
}
